var __jsx = React.createElement;
import Icon, { EyeFilled } from '@ant-design/icons';
import { AppContext } from "../../components/DixuApp/DixuApp";
import DixuButton from "../../components/DixuButton/DixuButton";
import DixuCard from "../../components/DixuCard/DixuCard";
import DixuContainer from "../../components/DixuContainer/DixuContainer";
import DixuCreatePurchaseOfferModal from "../../components/DixuCreatePurchaseOfferModal/DixuCreatePurchaseOfferModal";
import DixuDescriptionList from "../../components/DixuDescriptionList/DixuDescriptionList";
import DixuForm from "../../components/DixuForm/DixuForm";
import { DixuCol, DixuRow } from "../../components/DixuGrid/DixuGrid";
import DixuHead from "../../components/DixuHead/DixuHead";
import DixuImage from "../../components/DixuImage/DixuImage";
import DixuInput from "../../components/DixuInput/DixuInput";
import DixuLink from "../../components/DixuLink/DixuLink";
import DixuNotification from "../../components/DixuNotification/DixuNotification";
import DixuStepList from "../../components/DixuStepList/DixuStepList";
import DixuTable from "../../components/DixuTable/DixuTable";
import DixuText from "../../components/DixuText/DixuText";
import DixuTitle from "../../components/DixuTitle/DixuTitle";
import useIsLoading from "../../hooks/useIsLoading";
import { useTranslation } from "../../i18n";
import Area from "../../public/icons/area.svg";
import PriceTag from "../../public/icons/price_tag_eur.svg";
import React, { useContext, useState } from 'react';
import { followBidding, getErrorDescription, redirect } from "../../services/ApiService";
import { getImageUrl, getPostalCodeDetails, getStreetAddress } from "../../utils/DixuListingUtils";
import { LISTING_TYPE } from "../../utils/DixuConstants";
import { getTimeUntilBiddingCanBeAccepted } from "../../utils/DixuPurchaseOfferUtils";
import { formatNumber, formatPrice } from "../../utils/MoneyUtils";
import { getReferrerPath, toQueryString } from "../../utils/RouterUtils";
import RaisedHandsIcon from "../../public/icons/raised_hands.svg";
import { Space } from 'antd';
import theme from "../../SystemTheme";
import { toRem } from "../../utils/Utils";
const BiddingInfo = _ref => {
  let {
    listing
  } = _ref;
  const {
    t
  } = useTranslation(['listing']);
  const {
    user
  } = useContext(AppContext);
  const {
    0: purchaseOfferModalVisible,
    1: setPurchaseOfferModalVisible
  } = useState(false);
  const {
    bidding
  } = listing || {};
  const isApartment = listing.listingType === LISTING_TYPE.APARTMENT;
  const {
    purchaseOffers
  } = bidding || {};
  const {
    followerCount,
    debtlessStartPrice
  } = bidding || {};
  const getHighestOffer = offers => {
    if (!offers || offers.length === 0) {
      return null;
    }
    return offers.map(o => o.debtlessPriceOffer).reduce((a, b) => Math.max(a, b));
  };
  const debtlessPriceOffer = getHighestOffer(purchaseOffers);
  const columns = [{
    title: t('listing:Bidding.BiddingTable.Offerer'),
    dataIndex: 'primaryBuyer',
    width: 90
  }, {
    title: t('listing:Bidding.BiddingTable.OfferPrice'),
    dataIndex: 'debtlessPriceOffer',
    width: 140,
    render: price => formatPrice(price)
  }, {
    title: t('listing:Bidding.BiddingTable.Type'),
    dataIndex: 'hasPreconditions',
    width: 120,
    render: value => value !== null && t(`listing:Bidding.BiddingTable.HasPreconditions.${value.toString()}`)
  }, {
    title: t('listing:Bidding.BiddingTable.TimeUntilCanBeAccepted'),
    dataIndex: 'biddingOfferValidityStart',
    width: 140,
    render: (_biddingOfferValidityStart, data) => {
      const timeUntilCanBeAccepted = getTimeUntilBiddingCanBeAccepted(data);
      if (timeUntilCanBeAccepted === '-') {
        return /*#__PURE__*/React.createElement(DixuText, {
          color: "3-6"
        }, t('listing:Bidding.Expired'));
      }
      if (timeUntilCanBeAccepted === '0 tuntia') {
        return /*#__PURE__*/React.createElement(DixuText, {
          color: "9-6"
        }, t('listing:Bidding.CanBeAccepted'));
      }
      return timeUntilCanBeAccepted;
    }
  }];
  const ifLoggedIn = cb => {
    if (user) {
      return cb?.();
    }
    redirect(`/rekisteroidy${toQueryString({
      referrerPath: getReferrerPath()
    })}`);
    return undefined;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 20,
    xl: 24
  }, /*#__PURE__*/React.createElement(DixuCard, {
    title: /*#__PURE__*/React.createElement(DixuRow, {
      justify: "center",
      align: "middle",
      wrap: false
    }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
      font: "6"
    }, /*#__PURE__*/React.createElement(Icon, {
      component: RaisedHandsIcon
    }), ' ', t('listing:Bidding.Bidding')))),
    titleProps: {
      level: 1,
      appear: 2,
      weight: 'bold',
      margin: '24',
      hyphens: true,
      wrap: true
    },
    shadow: "2"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 24]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuDescriptionList, {
    vertical: true,
    iconProps: {
      style: {
        opacity: 0.4
      }
    },
    nameProps: {
      font: '2',
      color: '2-6'
    },
    valueProps: {
      font: '5'
    },
    hideFiltered: false,
    items: [{
      icon: /*#__PURE__*/React.createElement(EyeFilled, {
        style: {
          fontSize: toRem(32),
          color: theme.token.colorPrimary
        }
      }),
      name: t('listing:Bidding.FollowedBy'),
      value: t(followerCount === 1 ? 'listing:Bidding.XFollower' : 'listing:Bidding.XFollowers', {
        count: followerCount || 0
      })
    }, {
      icon: /*#__PURE__*/React.createElement(PriceTag, {
        style: {
          height: toRem(32)
        }
      }),
      iconProps: {
        fill: '1-6',
        height: toRem(32)
      },
      name: isApartment ? 'Velaton lähtöhinta' : 'Lähtöhinta',
      value: formatPrice(debtlessStartPrice),
      condition: debtlessStartPrice != null
    }, {
      icon: /*#__PURE__*/React.createElement(RaisedHandsIcon, null),
      iconProps: {
        style: {
          opacity: 0.8,
          height: toRem(32)
        }
      },
      name: 'Korkein tarjous',
      value: formatPrice(debtlessPriceOffer),
      placeholder: t('listing:ListingDetails.NoOffersYet'),
      condition: debtlessPriceOffer != null
    }]
  })), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuTitle, {
    level: "2",
    appear: "3",
    weight: "bold",
    margin: "0"
  }, t('listing:Bidding.Offers'))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuTable, {
    type: "plain",
    size: "small",
    dataSource: purchaseOffers,
    columns: columns,
    locale: {
      emptyText: t('listing:Bidding.NoReceivedOffers')
    },
    pagination: {
      total: purchaseOffers?.length,
      pageSize: 5,
      hideOnSinglePage: true
    },
    rowKey: "id"
  })))))), /*#__PURE__*/React.createElement(DixuCreatePurchaseOfferModal, {
    listing: listing,
    visible: purchaseOfferModalVisible,
    onCancel: () => setPurchaseOfferModalVisible(false)
  }));
};
const SellerInfo = _ref2 => {
  let {
    listing
  } = _ref2;
  const {
    t
  } = useTranslation(['listing']);
  const {
    realtor
  } = listing || {};
  const {
    avatar,
    name,
    jobTitle,
    email,
    tel,
    companyName,
    companyLogo
  } = realtor || {};
  const realtorDetails = [name, jobTitle].filter(Boolean).join(', ');
  return /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuTitle, {
    level: "4",
    weight: "bold",
    margin: "0",
    noSemantics: true
  }, t('listing:ListingSoldBy', {
    sellerDetails: realtor ? realtorDetails : t('listing:Bidding.SelfSeller')
  })), /*#__PURE__*/React.createElement(DixuTitle, {
    level: "5",
    margin: "12",
    noSemantics: true
  }, `${t('common:Phone')}: ${tel}, ${t('common:Email')}: ${email}`), companyName && /*#__PURE__*/React.createElement(DixuTitle, {
    level: "5",
    weight: "bold",
    margin: "12",
    noSemantics: true
  }, companyName)), (avatar || companyLogo) && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    type: "inline",
    justify: "center",
    align: "middle",
    gutter: [16, 16]
  }, avatar && /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuImage, {
    src: getImageUrl(avatar),
    type: "circle",
    width: "80",
    position: "left"
  })), companyLogo && /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuImage, {
    src: getImageUrl(companyLogo),
    aspectRatio: false,
    width: "160",
    height: "32",
    position: "left",
    fit: "contain"
  })))));
};
const ListingInfo = _ref3 => {
  let {
    listing
  } = _ref3;
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    thumbnails,
    typeOfApartment,
    area
  } = listing || {};
  const imgSrc = thumbnails?.[0];
  const streetAddress = getStreetAddress(listing);
  const postalCodeDetails = getPostalCodeDetails(listing);
  return /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 20,
    xl: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 8]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [16, 24]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 10,
    xl: 24
  }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 10
  }, /*#__PURE__*/React.createElement(DixuImage, {
    src: imgSrc,
    aspectRatio: "3:2",
    borderRadius: "lg"
  })))), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 14,
    xl: 24
  }, /*#__PURE__*/React.createElement(DixuTitle, {
    level: "2",
    weight: "bold",
    margin: "4",
    hyphens: true,
    wrap: true
  }, streetAddress), /*#__PURE__*/React.createElement(DixuTitle, {
    level: "4",
    noSemantics: true,
    margin: "4",
    hyphens: true,
    wrap: true
  }, postalCodeDetails), /*#__PURE__*/React.createElement(DixuTitle, {
    level: "5",
    noSemantics: true,
    margin: "4",
    hyphens: true,
    wrap: true
  }, typeOfApartment), area && /*#__PURE__*/React.createElement(DixuTitle, {
    level: "4",
    noSemantics: true
  }, /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement(Area, {
    style: {
      width: toRem(24),
      height: toRem(24)
    }
  }), /*#__PURE__*/React.createElement(DixuText, null, t('common:Units.SquareMeters', {
    area: formatNumber(area)
  }))))))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(SellerInfo, {
    listing: listing
  })), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 16]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 14
  }, /*#__PURE__*/React.createElement(DixuButton, {
    type: "ghost",
    size: "lg",
    href: "#info",
    block: true
  }, t('listing:Bidding.ReadMoreAboutBidding'))))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 14
  }, /*#__PURE__*/React.createElement(DixuButton, {
    type: "primary",
    size: "lg",
    href: "#follow",
    block: true
  }, t('listing:Bidding.FollowListingBidding'))))))))));
};
const Hero = _ref4 => {
  let {
    listing
  } = _ref4;
  return /*#__PURE__*/React.createElement(DixuContainer, null, /*#__PURE__*/React.createElement(DixuRow, {
    wrap: "reverse",
    gutter: [40, 40]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 12
  }, /*#__PURE__*/React.createElement(BiddingInfo, {
    listing: listing
  })), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 12
  }, /*#__PURE__*/React.createElement(ListingInfo, {
    listing: listing
  }))));
};
const WhatIsBidding = () => {
  const {
    t
  } = useTranslation(['listing', 'faq']);
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(DixuContainer, {
    maxWidth: "sm",
    className: "bg-2-1",
    id: "info"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 40]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuTitle, {
    level: "2",
    weight: "bold",
    align: "center",
    margin: "16"
  }, t('faq:Bidding.Items.WhatIsBidding.Title')), /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-8",
    align: "center",
    className: "m-b-16"
  }, t('faq:Bidding.Items.WhatIsBidding.Content')), /*#__PURE__*/React.createElement(DixuLink, {
    font: "3",
    color: "2-6",
    align: "center",
    weight: "bold",
    href: "/faq?tab=bidding"
  }, t('listing:Bidding.ReadMoreAboutBidding'))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuStepList, {
    lastStepCheck: true,
    items: [{
      name: t('listing:Bidding.BiddingSteps:Step1')
    }, {
      name: t('listing:Bidding.BiddingSteps:Step2')
    }, {
      name: t('listing:Bidding.BiddingSteps:Step3')
    }, {
      name: t('listing:Bidding.BiddingSteps:Step4')
    }, {
      name: t('listing:Bidding.BiddingSteps:Step5')
    }, {
      name: t('listing:Bidding.BiddingSteps:Step6')
    }]
  })))));
};
const FollowForm = _ref5 => {
  let {
    listing
  } = _ref5;
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    user
  } = useContext(AppContext);
  const {
    bidding
  } = listing || {};
  const {
    id: biddingID
  } = bidding || {};
  const [form] = DixuForm.useForm();
  const [onFinish, isSubmitting] = useIsLoading(async values => {
    try {
      await followBidding({
        biddingID,
        data: values
      });
      DixuNotification.success({
        message: t('listing:Bidding.FollowingStarted'),
        description: t('listing:Bidding.StartFollowingConfirmation', {
          email: values.email
        })
      });
      form.resetFields();
    } catch (error) {
      DixuNotification.error({
        message: t('listing:Bidding.ErrorFollowingBidding'),
        description: getErrorDescription(error)
      });
    }
  });
  const initialValues = {
    name: user?.displayName,
    email: user?.emails?.[0]?.value
  };
  return /*#__PURE__*/React.createElement(DixuContainer, {
    maxWidth: "sm",
    id: "follow"
  }, /*#__PURE__*/React.createElement("div", {
    className: "desktop-p-r-48 desktop-p-l-48"
  }, /*#__PURE__*/React.createElement(DixuCard, {
    title: t('listing:Bidding.FollowBiddingToGetToKnowOffers'),
    titleProps: {
      align: 'center'
    },
    shadow: "2"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 24]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-8",
    align: "center"
  }, t('listing:Bidding.FollowingIsFree'))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuForm, {
    form: form,
    name: "follow-bidding",
    initialValues: initialValues,
    onFinish: onFinish
  }, /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "name",
    label: t('common:Name'),
    rules: [{
      required: true
    }]
  }, /*#__PURE__*/React.createElement(DixuInput, null)), /*#__PURE__*/React.createElement(DixuForm.Item, {
    name: "email",
    label: t('common:Email'),
    rules: [{
      required: true,
      type: 'email'
    }]
  }, /*#__PURE__*/React.createElement(DixuInput, {
    type: "email"
  })), /*#__PURE__*/React.createElement(DixuButton, {
    type: "primary",
    size: "lg",
    shadow: "1",
    block: true,
    htmlType: "submit",
    loading: isSubmitting
  }, t('listing:Bidding.FollowBidding')))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuLink, {
    href: "/pdfs/Asiakas-_ja_markkinointirekisterin_tietosuojaseloste.pdf",
    font: "2",
    color: "2-6",
    align: "center",
    external: true
  }, t('listing:Bidding.PrivacyPolicy')))))));
};
const DixuBiddingScreen = _ref6 => {
  let {
    listing
  } = _ref6;
  const {
    t
  } = useTranslation(['listing']);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuHead, {
    title: t('listing:Bidding.BiddingPageTitle', {
      address: getStreetAddress(listing),
      city: listing?.city
    })
  }, /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: `${getStreetAddress(listing)}${listing?.districtFree && `, ${listing?.districtFree}`}, ${listing?.city}. ${listing?.typeOfApartment}`
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:image",
    content: listing?.thumbnails?.[0]
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(Hero, {
    listing: listing
  })), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(WhatIsBidding, null)), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(FollowForm, {
    listing: listing
  })))));
};
export default DixuBiddingScreen;